var render = function () {
  var _vm$form$message;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Announcement',
        to: {
          name: _vm.AnnouncementManagePath.name
        }
      }, {
        label: 'Add New'
      }],
      "title": "New Announcement"
    }
  }), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-md my-3"
  }, [_c('div', {
    staticClass: "flex-col w-1/3 mt-3 pr-4"
  }, [_c('label', {
    staticClass: "text-gray-600 text-sm font-semibold mb-3 block"
  }, [_vm._v("Title")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.title,
      expression: "form.title"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border rounded-lg w-full",
    attrs: {
      "id": "announcement-title",
      "placeholder": "e.g.: Maintenance Server",
      "type": "text",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": _vm.form.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value);
      }
    }
  }), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 mb-3 block"
  }, [_vm._v("Message")]), _c('div', {
    staticClass: "relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.message,
      expression: "form.message"
    }],
    staticClass: "bg-gray-50 py-2.5 px-2 border rounded-lg w-full",
    attrs: {
      "id": "announcement-description",
      "placeholder": "Write text here ...",
      "rows": "4",
      "maxlength": "200"
    },
    domProps: {
      "value": _vm.form.message
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "message", $event.target.value);
      }
    }
  }), _c('div', {
    staticClass: "text-right text-xs mt-1 text-gray-500"
  }, [_vm._v(" " + _vm._s((_vm$form$message = _vm.form.message) === null || _vm$form$message === void 0 ? void 0 : _vm$form$message.length) + "/200 ")])]), _c('DatetimeCustom', {
    staticClass: "mt-3 w-full",
    attrs: {
      "timeDate": true,
      "label": 'Start date'
    },
    model: {
      value: _vm.form.valid_from,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_from", $$v);
      },
      expression: "form.valid_from"
    }
  }), _c('DatetimeCustom', {
    staticClass: "mt-3 w-full",
    attrs: {
      "timeDate": true,
      "label": 'End date'
    },
    model: {
      value: _vm.form.valid_to,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid_to", $$v);
      },
      expression: "form.valid_to"
    }
  }), _c('label', {
    staticClass: "text-gray-600 text-sm font-semibold my-3 mb-3 block"
  }, [_vm._v("Status")]), _c('div', [_c('button', {
    staticClass: "w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none",
    class: {
      'bg-blue-700': _vm.form.is_active,
      'bg-gray-300': !_vm.form.is_active
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('span', {
    staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
    class: {
      'translate-x-6': _vm.form.is_active,
      'translate-x-0': !_vm.form.is_active
    }
  })])])], 1), _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "bg-blue-700 py-2 px-3 mt-3 rounded-lg text-white",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-white py-2 px-3 mt-3 rounded-lg text-gray-900 border ml-3"
  }, [_c('router-link', {
    staticClass: "text-gray-900 hover:no-underline hover:text-gray-900",
    attrs: {
      "to": {
        name: _vm.AnnouncementManagePath.name
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }